import { Configuration } from "app/models/configuration/configuration";

export class SiteSettings {
    private static instance: SiteSettings;

    configuration: Configuration;

    private constructor() { }

    public static getInstance(): SiteSettings {
        if (!SiteSettings.instance) {
            SiteSettings.instance = new SiteSettings();
        }

        return SiteSettings.instance;
    }

    setConfiguration(configurationParam: Configuration) {
        this.configuration = configurationParam;
    }

    getConfiguration(): Configuration {
        return this.configuration;
    }
    getCheckoutImage() {
        return this.configuration.chechout;
    }

    getInfoProductDetail() {
        return this.configuration?.infoProductDetail ?? true;
    }

}
